import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import * as actions from '../../../features/collections/redux/actions';
import { connect } from 'react-redux';
import { ViewItemDetails } from './ViewItemDetails';
export class ItemDetail extends Component {
  static propTypes = {
    collections: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };

  hideModal = () => {
    this.props.actions.closeItemDetailPage();
  };

  render() {
    const {
      collections: { selectedCollection, selectedItemWithDetails, isOpenItemDetail, projectDetail },
      projectId,
      version,
    } = this.props;
    if (!selectedCollection) {
      return '';
    }

    return (
      <ViewItemDetails
        isOpenItemDetail={isOpenItemDetail}
        hideModal={this.hideModal}
        projectDetail={projectDetail}
        projectId={projectId}
        selectedItemWithDetails={selectedItemWithDetails}
        selectedCollection={selectedCollection}
        version={version}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    collections: state.collections,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ItemDetail);
